import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "27",
  viewBox: "0 0 28 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_2464_63808)\"><path d=\"M16.6069 2.11475H21.5737C21.8827 2.11475 22.1333 2.36532 22.1333 2.67438V24.4301C22.1333 24.7392 21.8827 24.9897 21.5737 24.9897H16.6069C16.2979 24.9897 16.0473 24.7392 16.0473 24.4301V2.67438C16.0473 2.36532 16.2979 2.11475 16.6069 2.11475Z\" fill=\"white\"></path><path d=\"M6.11383 2.11475H11.0806C11.3896 2.11475 11.6402 2.36532 11.6402 2.67438V24.4301C11.6402 24.7392 11.3896 24.9897 11.0806 24.9897H6.11383C5.80478 24.9897 5.5542 24.7392 5.5542 24.4301V2.67438C5.5542 2.36532 5.80478 2.11475 6.11383 2.11475Z\" fill=\"white\"></path></g><defs><clipPath id=\"clip0_2464_63808\"><rect width=\"22.875\" height=\"22.875\" fill=\"white\" transform=\"translate(2.40625 2.11475)\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }